<template>
  <div>
  <Header />
  <v-btn
      ref="button"
      class="drawer-button"
      color="blue"
      dark
      @click="DateModal = true"
       style=" box-shadow: 1px 1px 18px rgb(0 99 145) !important;"
    >
      <v-icon style="  margin-left: -18px !important;
    font-size: 1.3rem !important;">mdi-calendar</v-icon>
    </v-btn>
 
 
  <div v-if="showChart && CounterSaleAbstract.length >0 " >
    <apexchart type="bar" height="430" :options="chartOptions" :series="series"></apexchart>
    <div style="padding-left: 10px; padding-right: 10px;padding-bottom: 25px;padding-top: 0;">
                <table style="width: 100%">
              


                  <tr style="padding-top: 2px" v-for="(item, i) in 3" :key="i" >
                    <td 
                      style="width: 100%; padding-bottom: 0px; padding-top: 12px;    padding-right: 14px;
    padding-left: 27px;"
                    
                    >

                         <v-system-bar  dark color="rgb(0, 143, 251)" style="color:#FFF;border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;">MB<v-spacer></v-spacer>2780.000</v-system-bar>
                    </td>

                  </tr>
                  
                </table>
              </div>
  </div>
  <v-dialog v-model="DateModal" max-width="500px">
             <v-card>
               <v-card-text style="padding-top: 45px;">
                <v-row>
                 <!--  <v-col cols="12">
                 
            <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        :return-value.sync="FromDate"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="FromDate"
            label="From Date"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker v-model="FromDate" no-title scrollable>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
          <v-btn text color="primary" @click="$refs.menu.save(FromDate)">OK</v-btn>
        </v-date-picker>
      </v-menu>
                  </v-col> -->
                  <v-col cols="12" style="padding-top: 0px;margin-top: -5px;">
                    
            <v-menu
        ref="menu1"
        v-model="menu1"
        :close-on-content-click="false"
        :return-value.sync="ToDate"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="ToDate"
            label="To Date"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker v-model="ToDate" no-title scrollable>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="menu1 = false">Cancel</v-btn>
          <v-btn text color="primary" @click="$refs.menu1.save(ToDate)">OK</v-btn>
        </v-date-picker>
      </v-menu>
                  </v-col>
                  <v-col cols="12" style="text-align: right;padding-top: 0px;">
                    <v-btn
                                  small
                                  color="green"
                                  style="color:#FFF"
                                   @click="GetCounterSaleSummary()"
                                  >ok</v-btn
                                >
                    </v-col>
                </v-row>
        
            
                
               </v-card-text>
   
             
             </v-card>
           </v-dialog>

           <div v-if ="CounterSaleAbstract.length  === 0">
        <v-container class="d-flex justify-center align-center fill-height">
 
 <v-row>
   <v-col cols="12" style="padding: 0px 70px 0px 70px;">
     <v-img
       :src="require('@/assets/images/empty.gif')"
       style="width: 100%;height:100%;"
     ></v-img>
   </v-col>
   <v-col cols="12" style="padding: 0px 70px 0px 70px;text-align: center;">
     <span style="font-size: 20px;font-weight: 400;color: red;">No Data Found</span>
   </v-col>
 </v-row>
</v-container>
</div>
</div>
</template>

<script>
 import Header from "../Pages/Header.vue";
 import axios from "axios";

export default {
  components: {
      Header
    },
  data() {
    return {
      bURL : localStorage.getItem('BaseURL'),
      FromDate: new Date().toISOString().substr(0, 10),
      ToDate: new Date().toISOString().substr(0, 10),
      menu: false,
      menu1:false,
      DateModal: false,
      check_date:null,
      showChart: false,
      lastClickTime: 0, // ← track clicks here
      series: [
        { name: 'Cash', data: [44, 55, 41, 64] },
        { name: 'Credit', data: [53, 32, 33, 52] },
        { name: 'Bank', data: [53, 32, 33, 52] },
        { name: 'Others', data: [53, 32, 33, 52] }
      ],
      chartOptions: {
  chart: {
    type: 'bar',
    height: 430,
    stacked: true,
    dropShadow: {
      enabled: true,
      blur: 1,
      opacity: 0.5
    },
    toolbar: {
      show: false // 👈 this disables the download/export menu
    },
    events: {
      dataPointSelection: (event, chartContext, config) => {
        const now = new Date().getTime();
        const diff = now - this.lastClickTime;

        if (diff < 400) {
          const category = config.w.globals.labels[config.dataPointIndex];
          this.handleDoubleClick(category, config.seriesIndex, config.dataPointIndex);
        }

        this.lastClickTime = now;
      }
    }
  },
  title: {
    text: 'Branch Wise Counter Sale Summary :-', // <- your chart title here
    align: 'left', // or 'center' / 'right'
    margin: 10,
    offsetX: 33,
    offsetY: 20,
    style: {
      fontSize: '15px',
      fontWeight: 'bold',
      color: 'rgb(35, 100, 170)'
    }
  },
  dataLabels: {
  enabled: false
},
  plotOptions: {
    bar: {
      horizontal: true,
      barHeight: '60%',
      dataLabels: {
     
        enabled:false,
      }
    },
    
  },
  // dataLabels: {
  //   enabled: true,
  //   formatter: function (val, opts) {
  //     const seriesIndex = opts.seriesIndex;
  //     const dataPointIndex = opts.dataPointIndex;
  //     const total = opts.w.config.series
  //       .map(s => s.data[dataPointIndex])
  //       .reduce((a, b) => a + b, 0);
  //     return seriesIndex === opts.w.config.series.length - 1 ? total : '';
  //   },
  //   offsetX: 35,
  //   style: {
  //     colors: ['#000'],
  //     fontSize: '14px',
  //     fontWeight: 'bold'
  //   }
  // },
  stroke: {
    show: true,
    width: 2,
    colors: ['#fff']
  },
  xaxis: {
    categories: ['HM', 'MB', 'HC', 'HS']
  },
  tooltip: {
    shared: false,
    y: {
      formatter: val => val
    }
  },
  fill: {
    type: 'pattern',
    opacity: 1,
    pattern: {
      style: ['circles', 'slantedLines', 'verticalLines', 'horizontalLines']
    }
  }
},
CounterSaleAbstract :[],

    }
  },
  mounted() {
    let today = new Date();
        let dd = String(today.getDate()).padStart(2, '0');
        let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        let yyyy = today.getFullYear();

        // today = yyyy + '-' + mm + '-' + '21';//dd ;
        today = yyyy + '-' + mm + '-' + dd ;
        this.TodayDate = today
        this.check_date = today;
   // this.showChart = true;

    // Assign chart event after mounting to retain `this` context
    this.chartOptions.chart.events = {
      dataPointSelection: (event, chartContext, config) => {
        const now = new Date().getTime();
        const diff = now - this.lastClickTime;

        if (diff < 400) {
          const category = config.w.globals.labels[config.dataPointIndex];
          this.handleDoubleClick(category, config.seriesIndex, config.dataPointIndex);
        }

        this.lastClickTime = now;
       
      }
    };
    //this.FromDate = "2025-03-29"
     //this.ToDate = "2025-03-29"
    this.GetCounterSaleSummary()
  },
  methods: {
    handleDoubleClick(category, seriesIndex, dataPointIndex) {
      
      //alert(`Double clicked on category: ${category}, seriesIndex: ${seriesIndex}, dataPointIndex: ${dataPointIndex}`);
      
      localStorage.setItem('CounterSaleDate', this.ToDate)
      localStorage.setItem('CounterSaleBranch', category)
      this.$router.push("Sales");

    
    },
    GetCounterSaleSummary()
      {
        this.showChart = false
        axios.get(this.bURL + "/api/counter/GetCounterSaleAbstract?FromDate="+this.ToDate+"&ToDate="+this.ToDate)
          .then(
            (response) => {
              this.DateModal = false
               this.CounterSaleAbstract = response.data.result
               this.chartOptions.xaxis.categories = []
               this.CashList  = []
               this.CreditList  = []
               this.CreditCardList  = []
               this.OthersList  = []
                for(this.i=0;this.i< this.CounterSaleAbstract.length;this.i++)
                {
                  this.chartOptions.xaxis.categories.push(this.CounterSaleAbstract[this.i].branchCode)
                  this.CashList.push(parseFloat( this.FormatewithDecimalPlacesNew(this.CounterSaleAbstract[this.i].cash))) 
                  this.CreditList.push(parseFloat( this.FormatewithDecimalPlacesNew(this.CounterSaleAbstract[this.i].credit))) 
                  this.CreditCardList.push(parseFloat( this.FormatewithDecimalPlacesNew(this.CounterSaleAbstract[this.i].creditCard))) 
                  this.OthersList.push(parseFloat( this.FormatewithDecimalPlacesNew(this.CounterSaleAbstract[this.i].others))) 
                }
                this.series = [
        { name: 'Cash', data: this.CashList },
        { name: 'Credit', data: this.CreditList },
        { name: 'Bank', data: this.CreditCardList },
        { name: 'Others', data: this.OthersList }
      ]
      this.showChart = true
            },
            (error) => {
              console.log("error" + error);
              this.error = "Something went wrong..!";
            }
          );
      },
      FormatewithDecimalPlacesNew(value) {
      this.number = localStorage.getItem("symbol");
      let val = (value / 1).toFixed(this.number).replace(".", ".");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      
    },
 
  },
  
  
}

</script>
<style scoped>
.drawer-button {
  position: fixed;
  top: 62px !important;
  right: -20px;
  z-index: 6;
  box-shadow: 1px 1px 18px #ee44aa;
}
</style>